import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import { useTracker } from '@dpdgroupuk/react-event-tracker';

import HeaderTabs from '../../components/LeftMenu/components/HeaderTabs';
import {
  getActiveTabIndex,
  parseQuery,
  stringifyQuery,
} from '../../utils/query';
import { NAV_PANEL } from '../../constants/analytics';
import layout from '../../components/styles/layout';

const useStyles = makeStyles(({ typography }) => ({
  sectionMenu: {
    width: `${layout.routeList.width}px`,
    background: '#303030',
    top: 0,
    left: 0,
    bottom: 0,
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    zIndex: 2,
  },
  listsContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: '#303030',
    height: `calc(100% - ${typography.pxToRem(48)})`,
  },
}));

const LeftMenu = ({ children }) => {
  const styles = useStyles();
  const tracker = useTracker();
  const { search, pathname } = useLocation();
  const activeTabIndex = getActiveTabIndex(pathname);
  const newSearch = useMemo(() => {
    // eslint-disable-next-line no-unused-vars
    const { routeId, sectionId, detailVisible, ...newQuery } =
      parseQuery(search);
    return stringifyQuery(newQuery);
  }, [search]);

  useEffect(() => {
    tracker.logEvent(NAV_PANEL.LOAD);
  }, [tracker]);

  const onChange = useCallback(
    (e, value) =>
      tracker.logEvent(NAV_PANEL[value ? 'SELECT_SECTIONS' : 'SELECT_ROUTES']),
    [tracker]
  );

  return (
    <Box className={styles.sectionMenu}>
      <HeaderTabs
        value={activeTabIndex}
        search={newSearch}
        onChange={onChange}
      />
      <Box className={styles.listsContainer}>{children}</Box>
    </Box>
  );
};

export default memo(LeftMenu);
